<template>
  <div class="cycle-container">
    <!-- 前N-1个带动画的元素 -->
    <transition 
      @enter="handleEnter"
      @leave="handleLeave"
      :css="false">
      <div 
        v-if="showItem"
        class="animated-text"
        :key="currentIndex">
        {{ currentText }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    texts: {
      type: Array,
      required: true,
      validator: val => val.length > 1
    },
    duration: {
      type: Number,
      default: 2000
    }
  },
  data() {
    return {
      currentIndex: 0,
      showItem: true,
    }
  },
  computed: {
    currentText() {
      return this.texts[this.currentIndex]
    }
  },
  mounted() {
    this.startTimer()
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    startTimer() {
      this.timer = setTimeout(() => {
        this.showItem = false
      }, this.duration)
    },
    
    handleEnter(el, done) {
      // 初始定位在下方
      el.style.transform = 'translateY(30px)'
      el.style.opacity = 0
      
      // 执行进入动画
      requestAnimationFrame(() => {
        el.style.transition = 'all 0.6s ease-out'
        el.style.transform = 'translateY(0)'
        el.style.opacity = 1
        
        el.addEventListener('transitionend', done, { once: true })
      })
    },
    
    handleLeave(el, done) {
      el.style.transition = 'all 0.5s ease-in'
      el.style.transform = 'translateY(-30px)'
      el.style.opacity = 0
      
      el.addEventListener('transitionend', () => {
        // 循环更新索引
        this.currentIndex = (this.currentIndex + 1) % this.texts.length
        this.showItem = true
        done()
        this.startTimer() // 持续启动新计时器
      }, { once: true })
    },
    
    clearTimer() {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.cycle-container {
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.animated-text, .static-text {
  width: 100%;
  text-align: left;
  will-change: transform, opacity;
}

.animated-text {
  /* 硬件加速优化 */
  backface-visibility: hidden;
  transform: translateZ(0);
}
</style>
